import axios, { AxiosResponse } from 'axios';

import { LeadsysPictureFilterItem } from '../interfaces/leadsys-picture-filter-item.interface';
import { LeadsysPictureFilters } from '../interfaces/leadsys-picture-filters.interface';
import { LeadsysPictureDto } from './dto/leadsys-picture-dto.interface';

const leadsysPictureFiltersEndpoint = 'leadsys-picture-filters';
const leadsysPictureSurveyFiltersEndpoint = 'leadsys-picture-filters/survey';
const leadsysPicturesEndpoint = 'leadsys-pictures';
const downloadLeadsysPicturesEndpoint = 'leadsys-pictures/download';

type BinaryData = any;

export const fetchLeadsysPictureFilters = async (baseApiUrl: string): Promise<LeadsysPictureFilters> => {
  const response: AxiosResponse<LeadsysPictureFilters> = await axios.get(`${baseApiUrl}/${leadsysPictureFiltersEndpoint}`);

  return response.data;
};

export const fetchLeadsysPictures = async (
  baseApiUrl: string,
  urlSearchParams: URLSearchParams,
  currentPage: number
): Promise<{ leadsysPictures: readonly LeadsysPictureDto[]; pageSize: number }> => {
  const response: AxiosResponse<{ leadsysPictures: readonly LeadsysPictureDto[]; pageSize: number; imagesCount: number }> = await axios.get(
    `${baseApiUrl}/${leadsysPicturesEndpoint}?currentPage=${currentPage}&${urlSearchParams.toString()}`
  );

  return response.data;
};

export const fetchSurveyFilters = async (
  baseApiUrl: string,
  typeIds: (string | number)[]
): Promise<{ surveyFilters: readonly LeadsysPictureFilterItem[] }> => {
  const params = new URLSearchParams();
  typeIds.forEach((typeId: number | string) => {
    params.append('types', typeId.toString());
  });

  const response: AxiosResponse<{ surveyFilters: readonly LeadsysPictureFilterItem[] }> = await axios.get(
    `${baseApiUrl}/${leadsysPictureSurveyFiltersEndpoint}?${params.toString()}`
  );

  return response.data;
};

export const downloadLeadsysPictures = async (baseApiUrl: string, pictureIds: number[]): Promise<BinaryData> => {
  const params = new URLSearchParams();
  pictureIds.forEach((pictureId: number) => {
    params.append('pictureId', String(pictureId));
  });

  const response: AxiosResponse<BinaryData> = await axios.get(`${baseApiUrl}/${downloadLeadsysPicturesEndpoint}?${params.toString()}`, {
    responseType: 'blob',
  });

  return response.data;
};

const leadsysPicturesAPI = {
  fetchLeadsysPictureFilters,
};

export default leadsysPicturesAPI;
